document.addEventListener("DOMContentLoaded", function () {
  const finalStepSubmitBtn = document.getElementById("final-submit-button"); // your form's final button
  if (!finalStepSubmitBtn) return;

  finalStepSubmitBtn.addEventListener("click", function (e) {
    e.preventDefault();

    // Replace these selectors with your real form input selectors
    const formData = {
      "Recipient Name": document.querySelector("#step-1 input[name='recipient_name']").value,
      "Name Pronunciation": document.querySelector("#step-1 input[name='name_pronunciation']").value,
      "Your Name": document.querySelector("#step-2 input[name='your_name']").value,
      "Occasion": document.querySelector("#step-2 select[name='occasion']").value,
      "Backstory": document.querySelector("#step-3 textarea[name='backstory']").value,
      "Quirks": document.querySelector("#step-3 textarea[name='quirks']").value,
      "Memories": document.querySelector("#step-3 textarea[name='memories']").value,
      "Inside Jokes": document.querySelector("#step-3 textarea[name='jokes']").value,
      "Style Preference": Array.from(document.querySelectorAll("#step-4 input[name='style']:checked")).map(el => el.value).join(", "),
      "Other Style": document.querySelector("#step-4 input[name='style_other']")?.value || "",
      "Artist Preference": document.querySelector("#step-4 select[name='artist']")?.value || "",
    };

    // Push to hidden attribute inputs
    for (const key in formData) {
      const input = document.querySelector(`input[name="attributes[${key}]"]`);
      if (input) input.value = formData[key];
    }

    // Finally, trigger Shopify's add-to-cart form submit
    document.querySelector("form[action='/cart/add']").submit();
  });
});
